// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

// Redirect bridge must run before this app's MSAL reads the auth hash.
import "./services/redirectBridge";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./services/AppInsightsService";
import "./i18n";
import initIcons from "./services/IconService/IconService";

import App from "./App";
import "./index.scss";

initIcons();

ReactDOM.render(
  <Suspense fallback={<>Loading...</>}>
    <App />
  </Suspense>,
  document.getElementById("root")
);
